import { AuthState } from '../RecoilStore';

const PERSIST_KEY = 'ministermore';

// axios 인터셉터는 React 트리 밖에서 동작하므로 recoil-persist가 쓰는
// sessionStorage를 직접 읽는다 (RecoilStore.tsx의 authState와 동일한 저장소).
export function getStoredAuthToken(): string | null {
  try {
    const raw = sessionStorage.getItem(PERSIST_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { authState?: AuthState | null };
    return parsed.authState?.token ?? null;
  } catch {
    return null;
  }
}

export function clearStoredAuth(): void {
  try {
    const raw = sessionStorage.getItem(PERSIST_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    delete parsed.authState;
    sessionStorage.setItem(PERSIST_KEY, JSON.stringify(parsed));
  } catch {
    // ignore
  }
}
